import styled from 'styled-components';
import { Notification as SBNotification } from '@econsult/econsult-ui/dist/components/Notification';
import { ParagraphBaseHeavy, TextFlow } from 'components/Typography';
import { TableContainer, TableHeaderDivider } from 'components/Table';
import { FlexSettingWrapper, Setting } from 'components/Setting/style';
import { InputRow } from 'components/Form';
import StyledButton from '@econsult/econsult-ui/dist/components/Button/ButtonStyles';

export const DemandManagementWrapper = styled(TableContainer)`
  gap: 1.5rem;
  padding-bottom: 3rem;

  ${TableHeaderDivider} {
    margin-bottom: 0;
  }

  ${TextFlow} {
    gap: 1.5rem;
  }
`;

export const DmOtherSettingsWrapper = styled(FlexSettingWrapper)`
  gap: 1.5rem;

  ${ParagraphBaseHeavy} {
    margin-bottom: -1rem;
  }
`;

export const MoreInfoWrapper = styled(TextFlow)`
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colorPrimaryPrimary10};
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const Notification = styled(SBNotification)`
  flex: 0;
  margin-bottom: 16px;
`;

export const ConsultationResponseTimeSetting = styled(Setting)`
  & ${InputRow} {
    display: grid;
    grid-template-columns: 1fr repeat(4, 0.5fr) 1fr;
    align-items: end;

    & > ${StyledButton} {
      grid-column: 6;
      white-space: nowrap;
    }
  }

`;
